import "./styles/common.css";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import { BrowserRouter, Routes, Route } from "react-router-dom";
function App() {
  const admin = JSON.parse(window.localStorage.getItem("admin"));
  console.log(admin);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={admin ? <Dashboard /> : <Login />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
